import React from 'react';
import { useNavigate } from 'react-router';
import LoginForm from './forms/LoginForm';
// import { useTranslation } from 'react-i18next';

import { getRoute, ROUTE_ENUMS } from '../../../helpers/routes';
import VideoBackground from '../../../components/VideoBackground';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

const Login = () => {
	// const { t } = useTranslation('login');
	const navigate = useNavigate();

	const handleSignUpNavigation = () => {
		navigate(getRoute(ROUTE_ENUMS.SIGN_UP), { replace: true });
	};

	// @TODO: Use the translator for this.

	return (
		<Stack flex={1} justifyContent="center">
			<VideoBackground>
				<Stack
					alignItems="center"
					justifyContent="center"
					margin={8}
					gap={3}
					flex={1}
				>
					<Paper
						sx={{
							border: '1px solid rgba(0,0,0,0.20)',
							backgroundColor: 'rgba(255, 255, 255, 0.1)',
							backdropFilter: 'blur(16px)'
						}}
						elevation={0}
					>
						<Stack padding={6} gap={2}>
							<Stack marginBottom={3}>
								<Typography variant="h4" color="glass.main">
									Welcome!
								</Typography>
								<Typography variant="caption" color="glass.main">
									Enter your details to log in to your Meistro account.
								</Typography>
							</Stack>
							<LoginForm />
							<Stack alignItems="center" direction="row" gap={1}>
								<Typography variant="caption" color="glass.main">
									Dont have an account?
								</Typography>
								<Typography
									variant="caption"
									component="span"
									sx={{
										textDecoration: 'underline',
										cursor: 'pointer'
									}}
									color="glass.main"
									onClick={handleSignUpNavigation}
								>
									Sign Up
								</Typography>
							</Stack>
						</Stack>
					</Paper>
				</Stack>
			</VideoBackground>
		</Stack>
	);
};

Login.propTypes = {};

export default Login;
